'use strict';
var totalPopulation = 0;
var population = document.getElementsByClassName('population');
for(var i = 0; i < population.length; i++){
    var populationNumber = parseInt(population[i].textContent.split(',').join(''));
    totalPopulation += populationNumber;
}
document.getElementsByClassName('total-population')[0].textContent = totalPopulation.toLocaleString();
document.getElementsByClassName('average-population')[0].textContent = Math.round(totalPopulation / population.length).toLocaleString();

//# sourceMappingURL=js_get_data_DOM.71a85594.js.map
